import { render, staticRenderFns } from "./SetupAlert.vue?vue&type=template&id=0e262fe8&scoped=true&"
import script from "./SetupAlert.vue?vue&type=script&lang=js&"
export * from "./SetupAlert.vue?vue&type=script&lang=js&"
import style0 from "./SetupAlert.vue?vue&type=style&index=0&id=0e262fe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e262fe8",
  null
  
)

export default component.exports